import * as EmbedGroup from './EmbedGroup';

// content creator
export const CONTENT_CREATOR_STOREFRONT = `${EmbedGroup.CONTENT_CREATOR}::storefront`;
export const CONTENT_CREATOR_DETAILS = `${EmbedGroup.CONTENT_CREATOR}::details`;

// legacy
export const MARKETPLACE_NAVIGATION_MENU = `${EmbedGroup.MARKETPLACE_EMBED}::navigation-menu`;

// sections
export const MARKETPLACE_COLLECTION_SECTION = `${EmbedGroup.MARKETPLACE_EMBED}::collection-section`;
export const MARKETPLACE_EXPLORE_SECTION = `${EmbedGroup.MARKETPLACE_EMBED}::explore-section`;
export const MARKETPLACE_SUGGESTION_SECTION = `${EmbedGroup.MARKETPLACE_EMBED}::suggestion-section`;

// modals
export const MARKETPLACE_COLLECTION_MODAL = `${EmbedGroup.MARKETPLACE_EMBED}::collection-modal`;
export const MARKETPLACE_EXPLORE_MODAL = `${EmbedGroup.MARKETPLACE_EMBED}::explore-modal`;
export const MARKETPLACE_LISTING_MODAL = `${EmbedGroup.MARKETPLACE_EMBED}::listing-modal`;
export const MARKETPLACE_SUGGESTION_MODAL = `${EmbedGroup.MARKETPLACE_EMBED}::suggestion-modal`;